function Layer () {
    return (
        <div className="g-layer">

            <div className="m-layer-content">
                <div className="m-layer-preview">
                    
                </div>
            </div>

        </div>
    )
}
export default Layer